import type { FieldErrors, UseFormRegisterReturn } from 'react-hook-form';
import { Input, Stack } from '@etg/wings';
import { useTranslation } from '@eti/providers';

interface TextInputProps {
  autoCapitalize?: string;
  autoCorrect?: string;
  'data-testid'?: string;
  errors: FieldErrors;
  isRequired?: boolean;
  label?: string;
  register: UseFormRegisterReturn;
  spellCheck?: boolean | 'true' | 'false';
}

const TextInput = ({
  autoCapitalize = 'off',
  autoCorrect = 'off',
  'data-testid': dataTestId,
  errors,
  isRequired,
  label,
  register,
  spellCheck = 'false',
}: TextInputProps) => {
  const { nonDebugT } = useTranslation();
  const { name } = register;
  const error = errors[name];
  const errorMessage = typeof error?.message === 'string' ? error.message : undefined;
  const errorId = `${name}-error`;

  return (
    <Stack spacing={4}>
      <Input.Label htmlFor={name}>
        {isRequired ? nonDebugT('Input.Field.Required', label) : label}
      </Input.Label>
      <Input
        autoCapitalize={autoCapitalize}
        autoCorrect={autoCorrect}
        data-testid={dataTestId}
        errorId={errorId}
        hasError={Boolean(error)}
        id={name}
        spellCheck={spellCheck}
        {...register}
      />
      <Input.Meta error={errorMessage} errorId={errorId} hasError={Boolean(error)} />
    </Stack>
  );
};

export default TextInput;
